import { Link } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { PRIVACY_POLICY } from './constants';
import { Root } from './styles';
import { type PrivacyPolicyProps } from './types';

export const PrivacyPolicy: FC<PrivacyPolicyProps> = ({ text, linkText, url }) => {
  const { getTestId } = useTestId();
  const LINK_PLACE = '{0}';
  const splitText: string[] = text.split(LINK_PLACE);

  if (!text || !linkText) {
    return null;
  }

  return (
    <Root
      data-testid={getTestId(PRIVACY_POLICY)}
      component="div"
      variant="caption"
    >
      {splitText[0]}
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkText}
      </Link>
      {splitText[1]}
    </Root>
  );
};
